import { routeName } from "../utils";
import pageConfig from "@/config/page";
const page = pageConfig.pages.game;

const name = "game";

export default {
  name,
  path: name,
  component: () => import("@/layout/routerView"),
  meta: {
    disable: true,
  },
  children: [
    {
      name: routeName("result", name),
      path: "result",
      component: page.result,
    },
    {
      path: "invest",
      name: routeName("invest", name),
      redirect: { name: routeName("invest.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          name: routeName("invest.index", name),
          path: "",
          component: page.invest,
          props: { isHistory: false },
        },
        {
          name: routeName("invest-detail", name),
          path: "bet",
          component: page.bet,
          props: true,
        },
      ],
    },
    {
      path: "history",
      name: routeName("history", name),
      redirect: { name: routeName("history.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          name: routeName("history.index", name),
          path: "",
          component: page.invest,
          props: { isHistory: true },
        },
        {
          name: routeName("history-detail", name),
          path: "bet",
          component: page.bet,
          props: true,
        },
      ],
    },
    {
      path: "language",
      name: routeName("language", name),
      component: page.language,
    },
  ],
};
